module.exports = __webpack_public_path__ + "media/images/horizon-854c0927523fdd1bc0e62296b8732383.jpg";